import React from 'react';

import classes from './MapLayersLegends.module.scss';
import { RiChargingPileFill, RiWirelessChargingLine } from 'react-icons/ri';
import { BsBatteryCharging } from 'react-icons/bs';

import { t } from 'i18next';
import classNames from 'classnames';
import { ConnectorPowerLabel, ConnectorStatus } from 'utils/enums/chargingType';

type Props = {
  selectedPowerType?: ConnectorPowerLabel[];
  onSelectPowerType?: (powerType: ConnectorPowerLabel) => void;
  connectorStatus?: ConnectorStatus;
  onConnectorStatusChange?: (status: ConnectorStatus) => void;
};

const MapLayersLegendsView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <div className={classNames(classes['labels'], classes['labels--powerType'])}>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.selectedPowerType?.includes(ConnectorPowerLabel.Slow),
          })}
          onClick={() => props.onSelectPowerType?.(ConnectorPowerLabel.Slow)}
        >
          <div>
            <RiChargingPileFill color="#0884fc" size={30} />
          </div>
          <span>{t('components.mapLayers.legend.powerType.slow')}</span>
        </div>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.selectedPowerType?.includes(ConnectorPowerLabel.Fast),
          })}
          onClick={() => props.onSelectPowerType?.(ConnectorPowerLabel.Fast)}
        >
          <div>
            <BsBatteryCharging color="#0884fc" size={30} />
          </div>
          <span>{t('components.mapLayers.legend.powerType.fast')}</span>
        </div>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.selectedPowerType?.includes(ConnectorPowerLabel.Turbo),
          })}
          onClick={() => props.onSelectPowerType?.(ConnectorPowerLabel.Turbo)}
        >
          <div>
            <RiWirelessChargingLine color="#0884fc" size={30} />
          </div>
          <span>{t('components.mapLayers.legend.powerType.turbo')}</span>
        </div>
      </div>

      <div className={classNames(classes['labels'], classes['labels--availability'])}>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.connectorStatus === ConnectorStatus.Free,
          })}
          onClick={() => props.onConnectorStatusChange?.(ConnectorStatus.Free)}
        >
          <div className={classNames(classes['circle'], classes['circle--available'])}></div>
          <span>{t('components.mapLayers.legend.availability.available')}</span>
        </div>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.connectorStatus === ConnectorStatus.Busy,
          })}
          onClick={() => props.onConnectorStatusChange?.(ConnectorStatus.Busy)}
        >
          <div className={classNames(classes['circle'], classes['circle--notAvailable'])} />
          <span>{t('components.mapLayers.legend.availability.notAvailable')}</span>
        </div>
        <div className={classNames(classes['label'], classes['nohover'])}>
          <div className={classNames(classes['circle'], classes['circle--selected'])} />
          <span>{t('components.mapLayers.legend.availability.selected')}</span>
        </div>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.connectorStatus === ConnectorStatus.Error,
          })}
          onClick={() => props.onConnectorStatusChange?.(ConnectorStatus.Error)}
        >
          <div className={classNames(classes['circle'], classes['circle--broken'])} />
          <span>{t('components.mapLayers.legend.availability.broken')}</span>
        </div>
        <div
          className={classNames(classes['label'], {
            [classes['label--selected']]: props.connectorStatus === ConnectorStatus.Unknown,
          })}
          onClick={() => props.onConnectorStatusChange?.(ConnectorStatus.Unknown)}
        >
          <div className={classNames(classes['circle'], classes['circle--unknown'])} />
          <span>{t('components.mapLayers.legend.availability.unknown')}</span>
        </div>
      </div>
    </div>
  );
};

MapLayersLegendsView.displayName = 'MapLayersLegendsView';
MapLayersLegendsView.defaultProps = {};

export default MapLayersLegendsView;
